import React from 'react';

export default (
  <svg
    css={{ width: '40px' }}
    width="34"
    height="34"
    viewBox="7.545 7.545 18.392 18.674"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Agency</title>
    <path
      d="M17.048 7.545c.825 0 1.59.516 1.865 1.276l4.89 12.997c.702 1.883 1.405 3.278 2.14 4.31v.091h-6.747a4.604 4.604 0 0 0 .252-3.856l-4.57-12.102-4.347 12.172a4.628 4.628 0 0 0 .287 3.787H7.546v-.091c.581-1.001 1.619-3.219 2.506-5.74l3.392-9.381c.55-1.517-.365-3.25-.428-3.372v-.09h4.033Z"
      fill="currentColor"
    />
  </svg>
);
